import React, { useEffect, useRef } from 'react';
import {TakisBtn, colorVariations} from './TakisButton.style'
import PropTypes from 'prop-types';

export default function TakisButton(props) {
  const classes = colorVariations();

  const {
    modifier,
    title,
    alt,
    href,
    ariaLabel,
    color,
    isActive,
    orientation,
    target,
    type,
    btnFunc,
    sendButton,
    imageContent
  } = props

  // exposing the button element ref
  const button = useRef(null);
  useEffect(()=>{
    if (button) {
      if (sendButton) {
        sendButton(button)
      }
    }
  }, [button,sendButton])


  TakisButton.propTypes = {
    title: PropTypes.string.isRequired,
    alt: PropTypes.string,
    href: PropTypes.string,
    ariaLabel:PropTypes.string,
    modifier: PropTypes.string,
    color: PropTypes.string,
    target: PropTypes.string,
    orientation:PropTypes.string,
    type: PropTypes.string,
    btnFunc: PropTypes.func,
    isActive: PropTypes.bool,
    imageContent: PropTypes.string
  };

  if(type!== "action"){
    return (
      <TakisBtn disableRipple
        className={`
          ${classes[color]}
          ${orientation && classes[orientation]}
          ${isActive ? 'fauxActive' : ''}
          ${modifier || ''}${imageContent ? classes.amazonBtn : ''}
        `}
        aria-label={ariaLabel}
        alt={alt}
        title={title}
        href={href}
        ref={button}
        {...props}
        target={target || '_self'}
        rel={target === '_blank' ? 'noopener' : '' }
        >
          {imageContent
            ? <img src={imageContent} alt={alt}/>
            : title
          }
      </TakisBtn>
      );
  }
  else{
    return (
      <TakisBtn disableRipple
        className={`${classes[color]} ${orientation && classes[orientation]} ${modifier || ''}`}
        aria-label={ariaLabel}
        alt={alt}
        title={title}
        ref={button}
        {...props}
        onClick={btnFunc}
        >
        {title}
      </TakisBtn>
      );
  }

}
